import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { usersAPI } from '../../api/api';

export const fetchUsers = createAsyncThunk('users/fetchAll', async () => {
  const response = await usersAPI.getAll();
  return response.data.data;
});

export const createUser = createAsyncThunk('users/create', async (data) => {
  const response = await usersAPI.create(data);
  return response.data.data;
});

export const updateUser = createAsyncThunk('users/update', async ({ id, data }) => {
  const response = await usersAPI.update(id, data);
  return response.data.data;
});

export const deleteUser = createAsyncThunk('users/delete', async (id) => {
  await usersAPI.delete(id);
  return id;
});

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        const index = state.items.findIndex((item) => item.id === action.payload.id);
        if (index !== -1) state.items[index] = action.payload;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.items = state.items.filter((item) => item.id !== action.payload);
      });
  },
});

export const { clearError } = usersSlice.actions;
export default usersSlice.reducer;
